import React, { useEffect } from 'react';
import { Button, Divider, Sidesheet } from '@innovaccer/design-system';

import ReviewUpdateDetails from '../../../../components/ReviewUpdate';

import standardETLNotification from '../../../../components/AlertService';

import api from '../../../../api';

const ReviewUpdate = (props) => {
  const [open, setOpen] = React.useState(true);
  const [releaseUrl, setReleaseUrl] = React.useState('');
  const [standardETLVersions, setStandardETLVersions] = React.useState({
    loading: true,
    data: [],
    error: false
  });
  const [selectedVersion, setSelectedVersion] = React.useState('');
  const [isUpdateTriggered, setIsUpdateTriggered] = React.useState(false);
  const [standardETLVersionDetails, setStandardETLVersionDetails] = React.useState({
    loading: true,
    data: {},
    error: false
  });
  const backdropClose = false;

  useEffect(() => {
    getStandardETlVersionsData();
    getReleaseNotesUrl();
  }, []);

  useEffect(() => {
    selectedVersion && getStandardETlVersionDetails(selectedVersion);
  }, [selectedVersion]);

  const getReleaseNotesUrl = () => {
    api
      .getReleaseNotesUrl()
      .then(({ l5_release_page_url }) => {
        setReleaseUrl(l5_release_page_url);
      })
      .catch(() => {
        setReleaseUrl('');
      });
  };
  const getStandardETlVersionsData = () => {
    api
      .getStandardETLVersions(props.currentVersion)
      .then((res) => {
        setStandardETLVersions({
          loading: false,
          data: res.versionList,
          error: false
        });
      })
      .catch(() => {
        setStandardETLVersions({
          loading: false,
          data: [],
          error: true
        });
      });
  };

  const getStandardETlVersionDetails = (selectedVersion) => {
    api
      .getStandardETLVersionDetails(selectedVersion)
      .then((res) => {
        setStandardETLVersionDetails({
          loading: false,
          data: res,
          error: false
        });
      })
      .catch(() => {
        setStandardETLVersionDetails({
          loading: false,
          data: {},
          error: true
        });
      });
  };

  const onClose = () => props.closeHandler();

  const handleVersionChange = (data) => {
    setSelectedVersion(data);
  };

  const updateStandardETL = () => {
    setIsUpdateTriggered(true);
    api
      .getUpdatedStandardETL({ version: selectedVersion })
      .then(() => {
        standardETLNotification({
          title: 'ETL has been updated',
          appearance: 'success'
        });
        props.getDeployedStandardETLDetails();
        onClose();
      })
      .catch(() => {
        standardETLNotification({
          title: 'Failed to update Standard ETL',
          appearance: 'alert'
        });
        setIsUpdateTriggered(false);
      });
  };

  const headerOptions = {
    heading: 'Review update'
  };
  const options = {
    open,
    onClose,
    backdropClose,
    headerOptions,
    stickFooter: true,
    seperator: true,
    footer: (
      <React.Fragment>
        <Button
          appearance="primary"
          className="mr-4"
          loading={isUpdateTriggered}
          disabled={!selectedVersion}
          onClick={updateStandardETL}
        >
          Update
        </Button>
        <Button appearance="basic" onClick={onClose}>
          Cancel
        </Button>
      </React.Fragment>
    )
  };

  return (
    <Sidesheet {...options}>
      <ReviewUpdateDetails
        selectedVersion={selectedVersion}
        standardETLVersions={standardETLVersions}
        standardETLVersionDetails={standardETLVersionDetails}
        releaseUrl={releaseUrl}
        handleVersionChange={handleVersionChange}
      />
    </Sidesheet>
  );
};

export default ReviewUpdate;
